module.exports = __webpack_public_path__ + "static/img/ramo.7ef2ba2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/ramo.jpg
// module id = DONU
// module chunks = 0